import type { MyTasksInbox, TaskSummary } from '@bits/shared/zod';

export function openTasksOf(inbox: MyTasksInbox | undefined): TaskSummary[] {
  if (!inbox) return [];
  return [...inbox.overdue, ...inbox.today, ...inbox.upcoming, ...inbox.later];
}

/**
 * Time can be declared against work that is already finished: a task created
 * and completed during the day still has to be accounted for at clock-out.
 */
export function declarableTasksOf(inbox: MyTasksInbox | undefined): TaskSummary[] {
  if (!inbox) return [];
  return [...openTasksOf(inbox), ...inbox.completed];
}

export function defaultOutcomeFor(task: TaskSummary): 'completed' | 'pending' {
  return task.statusKind === 'finished' ? 'completed' : 'pending';
}
